import React, { useEffect, useState } from "react";
import { getTranslations } from "../../../../../../services/languageUtils";

/**
 * Aba "Chave Pix": as chaves da conta, numa lista só.
 *
 * ── O que mudou, e por quê ──
 *
 * Eram DUAS listas — "chaves registradas" e "chaves aleatórias" — percorrendo o mesmo array
 * duas vezes, cada uma filtrando pelo tipo. A separação não dizia nada ao cliente: para ele
 * toda chave serve para receber, e o tipo é um detalhe de cada linha, não um capítulo.
 *
 * Saiu também o botão "gerar chave aleatória". O modal de criação faz os cinco tipos, incluindo
 * a aleatória, e um segundo caminho para o mesmo resultado só dá uma chance extra de criar
 * chave sem querer.
 *
 * ── Os nomes dos campos vêm do provedor ──
 *
 * A resposta traz `keyId`, `keyType` e `keyValue`. Este componente lia `key.key`, que não
 * existe: mesmo com a lista certa, o valor apareceria em branco. Os nomes alternativos são
 * aceitos porque o contrato da API tem variações entre rotas, e depender de um só faria a
 * coluna esvaziar no dia em que a outra forma chegasse.
 */

const ROTULO_TIPO = {
  CPF: "CPF",
  CNPJ: "CNPJ",
  EMAIL: "E-mail",
  PHONE: "Telefone",
  RANDOM: "Aleatória",
  EVP: "Aleatória",
};

function dadosDaChave(chave) {
  const tipo = chave.keyType || chave.type || "";
  return {
    id: chave.keyId || chave.id || chave.keyValue || chave.key,
    tipo,
    rotulo: ROTULO_TIPO[String(tipo).toUpperCase()] || tipo || "Chave",
    valor: chave.keyValue || chave.key || chave.value || "",
    status: String(chave.status || "").toUpperCase(),
  };
}

function TransferTypePixKey({ listKeys, deleteKey, handleButtonClick }) {
  const [translations, setTranslations] = useState({});
  const [copiada, setCopiada] = useState(null);

  useEffect(() => {
    getTranslations(localStorage.getItem("language") || "pt").then(setTranslations);
  }, []);

  const chaves = (Array.isArray(listKeys) ? listKeys : []).map(dadosDaChave).filter((c) => c.valor);

  async function copiar(valor) {
    try {
      await navigator.clipboard.writeText(valor);
      setCopiada(valor);
      setTimeout(() => setCopiada(null), 1800);
    } catch (err) {
      // Sem área de transferência (contexto não seguro, permissão negada), a chave continua à
      // vista para copiar à mão. O que não pode é a falha passar como se tivesse copiado.
      console.error("Não foi possível copiar a chave:", err);
    }
  }

  return (
    <div>
      <div className="mainContent100">
        <div style={{ maxWidth: "680px" }}>
          <p className="pTitle" style={{ margin: "10px 0px 4px 0px" }}>
            {translations.registered_pix_key || "Chaves Pix da conta"}
          </p>
          <p className="pLabel" style={{ marginBottom: 14 }}>
            Qualquer uma destas chaves recebe pagamentos nesta conta.
          </p>

          {chaves.length === 0 ? (
            <p className="labelGray">Nenhuma chave Pix cadastrada.</p>
          ) : (
            chaves.map((chave) => (
              <div
                key={chave.id}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: 12,
                  padding: "12px 14px",
                  marginBottom: 10,
                  border: "1px solid #eaecf0",
                  borderRadius: 8,
                  background: "#ffffff",
                  flexWrap: "wrap",
                }}
              >
                <div style={{ minWidth: 0, flex: "1 1 260px" }}>
                  <p
                    className="labelGray"
                    style={{ margin: 0, fontSize: 11, textTransform: "uppercase" }}
                  >
                    {chave.rotulo}
                  </p>
                  <b
                    style={{
                      fontFamily: "ui-monospace, Menlo, monospace",
                      fontSize: 13,
                      overflowWrap: "anywhere",
                    }}
                  >
                    {chave.valor}
                  </b>

                  {/*
                    Chave pendente aparece DIZENDO que está pendente: ela não recebe pagamento,
                    e listá-la igual às ativas faria o cliente divulgar uma chave que não
                    funciona.
                  */}
                  {chave.status === "PENDING" ? (
                    <p style={{ margin: "4px 0 0 0", fontSize: 11, color: "#b45309" }}>
                      pendente de confirmação — ainda não recebe
                    </p>
                  ) : null}
                </div>

                <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                  <button
                    type="button"
                    onClick={() => copiar(chave.valor)}
                    style={{
                      border: "1px solid #1c787e",
                      color: "#1c787e",
                      background: "transparent",
                      borderRadius: 6,
                      padding: "6px 14px",
                      fontSize: 13,
                      cursor: "pointer",
                    }}
                  >
                    {copiada === chave.valor ? "Copiado" : translations.copy || "Copiar"}
                  </button>

                  <div onClick={() => deleteKey(chave)} style={{ cursor: "pointer" }}>
                    <img
                      src={require("../../../../../../assets/imgs/delete.png")}
                      alt={translations.delete_image_alt}
                      className="deletePixKeyImg"
                    />
                  </div>
                </div>
              </div>
            ))
          )}

          {/*
            Um caminho só para criar. O modal cobre os cinco tipos, inclusive a aleatória — o
            botão "gerar chave aleatória" que existia aqui era um segundo caminho para o mesmo
            resultado, e criava sem confirmar nada.
          */}
          <div
            onClick={handleButtonClick}
            className="backButton"
            style={{ margin: "18px 0px 10px 0px" }}
          >
            <b>{translations.register_key || "Registrar chave"}</b>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TransferTypePixKey;
